var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kleptos-desktop"},[_c('div',{staticClass:"kleptos-desktop-wallpaper"}),_c('FileSystemIconView',{attrs:{"directory":_vm.desktop,"constrain":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }